import { render, staticRenderFns } from "./ADImg.vue?vue&type=template&id=6a80127f&scoped=true&"
import script from "./ADImg.vue?vue&type=script&lang=js&"
export * from "./ADImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a80127f",
  null
  
)

export default component.exports